import React from "react";
import { SecondaryButton } from "./shared";

// Confirmation before a live track is withdrawn from Creator and Business licensing (FR-MKT-005). The track stays live and
// keeps streaming; licences already sold stay valid until they expire.
export const WITHDRAW_LICENSING_TEXT =
  "No new licences can be bought. Existing licences stay valid until they expire. Streaming is not affected.";

export default function WithdrawLicensingDialog({ row, busy, onCancel, onConfirm }) {
  const name = row.title || "this track";
  return (
    <div
      className="fixed inset-0 z-50 flex [align-items:safe_center] justify-center overflow-y-auto bg-black/40 px-4 py-4"
      role="dialog" aria-modal="true" aria-labelledby="withdraw-licensing-title" data-testid="withdraw-licensing-dialog"
    >
      <div className="my-8 w-full max-w-lg rounded-2xl bg-white p-7 shadow-xl">
        <div className="flex items-start justify-between gap-4">
          <h2 id="withdraw-licensing-title" className="text-2xl font-bold text-gray-900">Withdraw “{name}” from licensing?</h2>
          <button type="button" onClick={onCancel} disabled={busy} aria-label="Close" className="text-2xl leading-none text-gray-500">×</button>
        </div>
        <p className="mt-3 text-sm text-gray-600" data-testid="withdraw-licensing-note">{WITHDRAW_LICENSING_TEXT}</p>
        <div className="mt-6 flex justify-end gap-3">
          <SecondaryButton onClick={onCancel} disabled={busy} data-testid="withdraw-licensing-cancel">Cancel</SecondaryButton>
          <button
            type="button" onClick={onConfirm} disabled={busy} data-testid="withdraw-licensing-confirm"
            className="rounded-full bg-red-600 px-7 py-3 font-semibold text-white hover:bg-red-700 disabled:opacity-60"
          >
            {busy ? "Withdrawing…" : "Withdraw"}
          </button>
        </div>
      </div>
    </div>
  );
}
